// 日曜始まりの曜日リスト
// 多言語対応の場合はi18n採用した方がいい
export const WEEKDAY_LIST = ['日', '月', '火', '水', '木', '金', '土'];
export const WEEKDAY_LIST_EN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// （日曜始まり）日曜日のインデックス番号
export const SUN_INDEX = 0;

// （日曜始まり）土曜日のインデックス番号
export const SAT_INDEX = 6;
